<template>
  <a-modal
    v-model="showModal"
    :title="title"
    width="450px"
    :footer="null"
    :maskClosable="false"
    :dialogStyle="{ top: '10%' }"
    @cancel="handleCancel"
  >
    <form>
      <div>
        <div class="create_account_item">
          <span class="create_account_item_label">手机号码：</span>
          <a-input
            class="create_account_item_input"
            v-model.trim="account.phone"
            :maxLength="25"
            placeholder="请输入手机号"
          />
          <span
            :class="[
              'verify_code',
              code.hasSend ? 'verify_code_count_down' : 'send_verify_code',
            ]"
            @click="sendCode"
            >{{ code.codeMsg }}</span
          >

        </div>
        <div class="create_account_item">
          <span class="create_account_item_label">验证码：</span>
          <a-input
            class="create_account_item_input"
            v-model.trim="account.verifyCode"
            :maxLength="6"
            placeholder="请输入验证码"
          />
        </div>
        <div class="create_account_item">
          <span class="create_account_item_label">账号姓名：</span>
          <a-input
            class="create_account_item_input"
            :maxLength="15"
            v-model.trim="account.username"
            placeholder="请输入账号姓名"
          />
        </div>
          <div class="create_account_item">
          <span class="create_account_item_label">密码：</span>
          <a-input-password
            class="create_account_item_input"
            :maxLength="25"
            v-model.trim="account.password"
            autocomplete="off"
            placeholder="请输入密码"
          />
        </div>
          <div class="create_account_item">
          <span class="create_account_item_label">确认密码：</span>
          <a-input-password
            class="create_account_item_input"
            :maxLength="25"
            v-model.trim="account.confirmPassword"
            autocomplete="off"
            placeholder="请输入确认密码"
          />
        </div>
        <div class="create_account_item">
          <span class="create_account_item_label">结算方式：</span>
          <a-select class="create_account_item_input" v-model="account.bpmUserType">
            <a-select-option value="0"> 自付 </a-select-option>
            <a-select-option value="1"> 代付 </a-select-option>
          </a-select>
        </div>
        <div class="create_account_item">
          <span class="create_account_item_label">流量包价格：</span>
          <a-select class="create_account_item_input" v-model="account.ifShowPrice">
            <a-select-option value="0"> 显示 </a-select-option>
            <a-select-option value="1"> 隐藏 </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="create_account_div create_account_btn">
        <span class="create_account_cancel" @click.prevent="cancel">取消</span>
        <span class="create_account_confirm" @click.prevent="confirm">新增</span>
      </div>
    </form>
  </a-modal>
</template>
<script>
import {isNull,successMsg, errMsg, warnMsg} from "../../../utils/CommonUtils.js"
export default {
  props: ["visible"],
  data() {
    return {
      title: "创建分销账号",
      showModal: false,
      code: {
        timeInterval: "", //倒计时对象
        hasSend: false,
        codeMsg: "发送验证码",
      },
      account: {
        verifyCode: "",
        phone: "",
        username: "",
        password: "",
        confirmPassword: "",
        ifShowPrice: "0",
        bpmUserType: "0",
      },
    };
  },
  watch: {
    visible(val) {
      this.showModal = val;
      if (!this.showModal) {
        this.reset();
        this.changeSendVerifyCodeContent();
      }
    },
  },
  methods: {
    /** 关闭弹框后，清除倒计时 */
    changeSendVerifyCodeContent() {
      this.code.codeMsg = "发送验证码";
      this.code.hasSend = false;
      clearInterval(this.code.timeInterval);
    },

    cancel() {
      this.$emit("create-account-visible", false, 0);
    },

    confirm() {
      var phoneReg = /^[0-9]{3,20}$/g
      var codeReg = /^[0-9]{6}$/g
      if (isNull(this.account.phone)) {
        warnMsg("手机号不能为空");
        return;
      }
      if(!phoneReg.test(this.account.phone)){
        warnMsg("手机号格式不正确");
        return;
      }
      if (isNull(this.account.verifyCode)) {
        warnMsg("验证码不能为空");
        return;
      }
      if(!codeReg.test(this.account.verifyCode)){
        warnMsg("验证码错误");
        return;
      }
      if (isNull(this.account.username)) {
        warnMsg("账号姓名不能为空");
        return;
      }
      if(isNull(this.account.password)){
         warnMsg("密码不能为空");
        return;
      }
      if(isNull(this.account.confirmPassword)){
         warnMsg("确认密码不能为空");
        return;
      }
      if(this.account.confirmPassword != this.account.password){
         warnMsg("密码与确认密码不一致");
        return;
      }
      if(this.account.password.length < 6){
        warnMsg("密码长度不能小于6位")
        return;
      }
      let param = {
        phoneNumber: this.account.phone,
        realName: this.account.username,
        code: this.account.verifyCode,
        password: this.account.password,
        confirmPassword: this.account.confirmPassword,
        bpmUserType: this.account.bpmUserType,
        ifShowPrice: this.account.ifShowPrice,
      }
      this.axios.post(this.baseUrl + "addAccount",param,
        {headers: { token: sessionStorage.getItem("token") }}).then((res)=>{
        if(res.status == 200){
          if(res.data.code == 0){
             successMsg("创建成功")
             this.$emit("create-account-visible", false, 1);
          }else if(res.data.code == -1){
            warnMsg("请先登录");
            setTimeout(() => {
              this.$router.push({ name: "login" });
            }, "2000");
          }else if(res.data.code == 2){
            warnMsg("验证码已过期")
            this.changeSendVerifyCodeContent()
          }else if(res.data.code == -4){
            warnMsg("您不是主账号，没有操作权限");  
          }    
        }else{
          errMsg("发送短信失败")
        }
      }).catch(()=>{
        errMsg("系统异常，请联系客服")
      })  
    },
     /** 右上角 'X' 关闭按钮调用 */
    handleCancel() {
      this.$emit("create-account-visible", false, 0);
    },
    reset(){
      this.account.phone = "";
      this.account.username = ""; 
      this.account.verifyCode = "";
      this.account.password = "";
      this.account.confirmPassword = "";
    },
    /** 发送短信 */
    sendCode() {
      var phoneReg = /^[0-9]{3,20}$/g
      if (isNull(this.account.phone)) {
         warnMsg("手机号不能为空");
        return;
      }
      if(!phoneReg.test(this.account.phone)){
        warnMsg("手机号格式不正确");
        return;
      }
      this.axios.post(this.baseUrl + "getCode?phonenumber="+this.account.phone, "",
        {headers: { token: sessionStorage.getItem("token") }}).then((res)=>{
        if(res.status == 200){
          if(res.data.code == 0){
            successMsg("短信发送成功，请注意接收")
            this.countDown();
          }else if(res.data.code == -1){
            warnMsg("请先登录");
            setTimeout(() => {
              this.$router.push({ name: "login" });
            }, "2000");
          }else if(res.data.code == -4){
            warnMsg("账号已存在");
          }   
        }else{
          errMsg("发送短信失败")
        }
      }).catch(()=>{
        errMsg("系统异常，请联系客服")
      })  
    },

    /** 发送短信后，倒计时 */
    countDown(){
      var i = 59;
      this.code.hasSend = true;
      this.code.codeMsg = "60s后重新获取";
      this.code.timeInterval = setInterval(() => {
        if (i > 0) {
          this.code.codeMsg = i-- + "s后重新获取";
        } else {
          this.changeSendVerifyCodeContent();
        }
      }, 1000);
    }
  },
};
</script>
<style scoped>
.verify_code {
  display: inline-block;
  text-align: center;
  height: 30px;
  line-height: 30px;
  padding: 0px 5px;
  border-radius: 3px;
  margin-left: 5px;
}
.verify_code_count_down {
  pointer-events: none;
  cursor: default;
  border: 1px solid #d9d9d9;
  color: #d9d9d9;
}

.send_verify_code {
  border: 1px solid rgb(211, 211, 211);
  box-shadow: 0px 0px 2px 0px rgb(241, 241, 241);
}
.send_verify_code:hover {
  cursor: pointer;
  color: rgb(137, 208, 255);
  border: 1px solid rgb(137, 208, 255);
}
.send_verify_code:active {
  color: rgb(66, 178, 252);
}
.create_account_item {
  width: 100%;
  margin-bottom: 12px;
}

.create_account_item_label {
  display: inline-block;
  width: 85px;
  text-align: justify;
  text-align-last: justify;
}
.create_account_item_input {
  width: 50%;
}

.create_account_div {
  margin-bottom: 10px;
  font-size: 15px;
}
.create_account_btn {
  text-align: center;
  margin: 20px 0 0 0;
}
.create_account_cancel,
.create_account_confirm {
  border-radius: 5px;
  text-align: center;
  display: inline-block;
  height: 33px;
  width: 60px;
  line-height: 33px;
}
.create_account_cancel {
  margin-right: 15px;
  border: 1px solid rgb(184, 184, 184);
}
.create_account_cancel:hover {
  cursor: pointer;
  border: 1px solid rgb(78, 78, 255);
  color: rgb(78, 78, 255);
}
.create_account_confirm {
  border: 1px solid rgb(78, 78, 255);
  background-color: rgb(78, 78, 255);
  color: white;
}
.create_account_confirm:hover {
  cursor: pointer;
  box-shadow: 0px 0px 2px 0px rgb(23, 23, 255);
}
</style>
